import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-[100%]" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = { class: "flex justify-center" }

import { toRefs, onMounted, ref } from 'vue';
  
  import { post } from '@/api/api';
  
  interface Props {
    form: any;
    isBackNavigation?: boolean; // 添加返回导航标识
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'fourStep',
  props: {
    form: {},
    isBackNavigation: { type: Boolean }
  },
  setup(__props: any) {

  const props = __props;
  const { form, isBackNavigation } = toRefs(props);
  const loading = ref(false);
  
  const generateAbstract = async () => {
    loading.value = true;
    try {
      const res = await post('/aiGenerate/digest', {
        title: form.value.name, // 使用第一步的标题字段
        content: '', // 将content字段设为空字符串
        keywords: Array.isArray(form.value.keywords) ? form.value.keywords.join(',') : form.value.keywords,
        literature: Array.isArray(form.value.literature)
          ? form.value.literature.map((item: any) => item.quote).join(',')
          : form.value.literature,
      });
      if (res && res.data && res.data.data) {
        form.value.abstract = res.data.data;
      }
    } catch (error) {
      console.error('生成摘要失败:', error);
    } finally {
      loading.value = false;
    }
  };
  
  onMounted(() => {
    // 只有在非返回导航或者摘要为空时才调用API
    // 如果是返回导航且已有摘要数据，则不重新请求
    if (!isBackNavigation?.value || !form.value.abstract) {
      generateAbstract();
    }
  });
  
  const handleGenerate = () => {
    console.log('重新生成');
    generateAbstract();
  };
  
return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_Button = _resolveComponent("el-Button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form_item, {
      class: "mobile-form-item",
      "label-width": "0"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: _unref(form).abstract,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).abstract) = $event)),
            placeholder: "请输入摘要内容",
            type: "textarea",
            rows: 6,
            class: "mobile-textarea"
          }, null, 8, ["modelValue"])
        ])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_Button, {
          type: "primary",
          onClick: handleGenerate,
          loading: loading.value,
          class: "mobile-button"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("重新生成")
          ])),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ], 64))
}
}

})